
import { TAppState } from "@/lib/interface";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: TAppState = {
  loading: false,
  language:undefined,
  countrySlug:""
};

export const slice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateLoading: (
      state: typeof initialState,
      action: PayloadAction<boolean>
    ) => {
      state.loading = action.payload;
    },
    updateLanguage: (
      state: typeof initialState,
      action: PayloadAction<any>
    ) => {
      state.language = action.payload;
    },
    updateCountry: (
      state: typeof initialState,
      action: PayloadAction<string>
    ) => {
      state.countrySlug = action.payload;
    },
  },
});

export const { updateLoading , updateLanguage , updateCountry} = slice.actions;
export default slice.reducer;
